export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_640000-d0bb46aa980a66f6282357ed04faadfb.avif";